import { LegalPage, TERMS } from "@agent-todo/shared-ui"
import { createFileRoute } from "@tanstack/react-router"

import { Navbar } from "@/components/Navbar"

export const Route = createFileRoute("/terms")({
  component: () => (
    <>
      <Navbar />
      <LegalPage doc={TERMS} />
    </>
  ),
})
